import { Component, forwardRef } from '@angular/core';
import { BaseFormComponent } from '../../global/BaseFormComponent';
import { NG_VALUE_ACCESSOR, FormControl, Validators, FormGroup } from '@angular/forms';
import { WhiteSpacesValidator } from 'src/app/validators/whitespaces-validator'
import { DatesValidator } from 'src/app/validators/dates-validator'
import { PatternValidator } from 'src/app/widgets/global/Validators';

@Component({
  standalone: false,
  selector: 'app-detail-form',
  templateUrl: './detail-form.component.html',
  styleUrls: ['./detail-form.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => DetailFormComponent),
    multi: true
  }]
})

export class DetailFormComponent extends BaseFormComponent {

  minDate: Date;


  constructor(private whiteSpacesValidator: WhiteSpacesValidator, private datesValidator: DatesValidator) {
    super();

    this.minDate = new Date();

    this.form = new FormGroup({
      name: new FormControl('', [Validators.required, this.whiteSpacesValidator.validate()]),
      // category: new FormControl('', [Validators.required]),
      eventType: new FormControl('', [Validators.required]),
      eventDates: new FormControl('', [Validators.required]),
      // daysOfWeek: new FormControl('', [Validators.required]),
      // frequency: new FormControl('OnceOff', [Validators.required]),
      // occurrenceType: new FormControl('', [Validators.required]),
      // onceOffDate: new FormControl('', [Validators.required, this.datesValidator.validate("onceOffDate", null, {"pastDate":true})]),
      // dateStart: new FormControl('', [Validators.required, this.datesValidator.validate("dateStart", "dateEnd", {"dates":true}), this.datesValidator.validate("dateStart", null, {"pastDate":true})]),
      // dateEnd: new FormControl('', [Validators.required, this.datesValidator.validate("dateStart", "dateEnd", {"dates":true}), this.datesValidator.validate(null, "dateEnd", {"pastDate":true})]),
      timeStart: new FormControl('', [PatternValidator.pattern("^([0][0-9]:[0-5][0-9])|([1][0-9]:[0-5][0-9])|([2][0-3]:[0-5][0-9])$", "please provide a valid time in format of XX:XX (e.g. 12:39)")]),
      timeEnd: new FormControl('', [PatternValidator.pattern("^([0][0-9]:[0-5][0-9])|([1][0-9]:[0-5][0-9])|([2][0-3]:[0-5][0-9])$", "please provide a valid time in format of XX:XX (e.g. 12:39)")]),
    });


    this.onValueChanged(p => {
      this.setValues(p.name as string, p.eventType as string, p.timeStart as string, p.timeEnd as string);
    });


    this.form.controls['eventType'].valueChanges.subscribe(value => {
            /**
       * A Festival MUST have a start date and may have a start time.
         All Events MUST have a start date and time.
       */
      const timeStartControl = this.form.controls["timeStart"];
      if(value === "Festival"){
        timeStartControl.setValidators([PatternValidator.pattern("^([0][0-9]:[0-5][0-9])|([1][0-9]:[0-5][0-9])|([2][0-3]:[0-5][0-9])$", "please provide a valid time in format of XX:XX (e.g. 12:39)")]);
      }else{
        timeStartControl.setValidators([PatternValidator.pattern("^([0][0-9]:[0-5][0-9])|([1][0-9]:[0-5][0-9])|([2][0-3]:[0-5][0-9])$", "please provide a valid time in format of XX:XX (e.g. 12:39)"), Validators.required]);
      }

      this.form.controls["timeStart"] = timeStartControl;
      this.form.controls["timeStart"].updateValueAndValidity();
    });

    this.form.valueChanges.subscribe(values => {
      this.value.name = values.name;
      this.value.eventType = values.eventType;
      this.value.eventDates = values.eventDates;
      this.value.timeStart = values.timeStart;
      this.value.timeEnd = values.timeEnd;
    });


    //TODO : make this automatic on the bind.
    // this.setOccurrenceType("OnceOff");

  }

  // setFrequency(frequency){
  //   switch (frequency){
  //     case "Weekly":
  //     case "TwoWeeks":
  //       this.form.get('daysOfWeek').enable();
  //       break;
  //     default:
  //         this.form.get('daysOfWeek').disable();
  //         break;
  //   }
  // }

  // setOccurrenceType(occurrenceType) {
  //   switch (occurrenceType) {
  //     case "OnceOff":
  //       this.form.get('onceOffDate').enable();
  //       this.form.get('dateStart').disable();
  //       this.form.get('dateEnd').disable();
  //       break;

  //     case "OccursBetween":
  //       this.form.get('onceOffDate').disable();
  //       this.form.get('dateStart').enable();
  //       this.form.get('dateEnd').enable();
  //       break;

  //     case "SpecificDates":
  //       this.form.get('onceOffDate').disable();
  //       this.form.get('dateStart').disable();
  //       this.form.get('dateEnd').disable();
  //       break;
  //   }
  // }


  setValues(name: string, eventType: string, timeStart: string, timeEnd: string): void {
    this.form.get('name').setValue(name);
    this.form.get('eventDates').setValue(this.value.eventDates);
    this.form.get('eventType').setValue(eventType);
    this.form.get('timeStart').setValue(timeStart);
    this.form.get('timeEnd').setValue(timeEnd);
  }
}
